import { useHospitalDetailContext } from '../hospital-detail-context'

import { DoctorSection } from '@/features/hospital/components/doctor-section'

export const HospitalDetailDoctors = () => {
  const { user, hospital, doctors, analytics } = useHospitalDetailContext()

  return (
    <DoctorSection
      user={user}
      doctors={doctors}
      onClickMoreList={(target) => {
        analytics.trackMoreListClick(target)
      }}
      emitDoctorClickedWithEvent={(args) => {
        analytics.trackDoctorClick(args.doctorId)
      }}
      emitDoctorViewedWithEvent={(args) => {
        // DoctorViewed 이벤트는 기본적으로 analytics에서 처리되므로
        // 추가적인 로직이 필요한 경우에만 여기서 처리
      }}
      hospitalId={hospital.hospitalId}
    />
  )
}
